import React from 'react';
import List from 'material-ui/List';
import ListItem from 'material-ui/List/ListItem';
import ListItemText from 'material-ui/List/ListItemText';
import Field from './Field';

const fieldOrder={
    time:1,
    type:2,
    health:3,
    x:4,
    y:5,
    sensor:6,
    error:7
};

const OccasionList=({ occasions } )=> {
    return (
        <div className='occasion-list'>
            <List component="nav" dense={true}>
                {occasions.map((occasion, index)=>(
                    <ListItem button key={index}>
                        {Object.keys(occasion)
                            .sort((key1,key2)=>{return fieldOrder[key1]-fieldOrder[key2];})
                            .map((key)=>(<Field object={occasion} field={key} key={key} />))}
                    </ListItem>
                ))}

            </List>
        </div>
    );
};

export default OccasionList;